/**
 * 共享 i18n 實例
 *
 * 供 Pinia store 直接使用 i18n.global.t，避免在非 setup 環境呼叫 useI18n()
 */

import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import zhTw from './locales/zh-tw.json'
import zhCn from './locales/zh-cn.json'
import ja from './locales/ja.json'

export const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    'zh-tw': zhTw,
    'zh-cn': zhCn,
    ja
  }
})
